/**
 * Header search: ConvertCart owns typeahead + full-results overlay when its bundle
 * loads. When the bundle is blocked (Firefox ETP, ad blockers), Enter / Search
 * falls back to native Shopify /search?q=…
 */
(function () {
  var INPUT_SEL = '.clnf-search-input';
  var SUBMIT_SEL = '.cch-search-submit';
  var CC_SRC = 'cdn.convertcart.com/73605427';
  var CC_WAIT_MS = 3500;
  var CC_HANDOFF_FALLBACK_MS = 1200;

  var bundleReady = false;
  var bundleFailed = false;
  var forwardingEnter = false;
  var ccObserver = null;

  function disconnectCcObserver() {
    if (ccObserver) {
      ccObserver.disconnect();
      ccObserver = null;
    }
  }

  function trackCcScript(script) {
    if (!script || script.tagName !== 'SCRIPT' || !script.src) return;
    if (script.src.indexOf(CC_SRC) === -1) return;
    if (script.dataset.clnfCcTracked) return;
    script.dataset.clnfCcTracked = '1';
    script.addEventListener('load', function () {
      bundleReady = true;
      disconnectCcObserver();
    });
    script.addEventListener('error', function () {
      bundleFailed = true;
      disconnectCcObserver();
    });
    // The bundle is async and injected at the end of <body>, so on a warm cache it has
    // usually loaded before this deferred script runs, and its load event is already gone.
    // (script.readyState only ever existed on old IE.) A Resource Timing entry for the
    // src means the fetch completed; if it was actually a failed fetch,
    // commitToConvertCart() still falls back to native search when no overlay appears.
    if (fetchFinished(script.src)) {
      bundleReady = true;
      disconnectCcObserver();
    }
  }

  function fetchFinished(src) {
    try {
      return !!(window.performance && performance.getEntriesByName &&
        performance.getEntriesByName(src, 'resource').length);
    } catch (e) {
      return false;
    }
  }

  /**
   * ConvertCart's loader inserts its <script> via insertBefore(getElementsByTagName('script')[0]),
   * which lands in <head> (the first script tag on this theme). Scope the observer there instead of
   * documentElement so it isn't re-running on every body mutation (cart drawer, Vue re-renders,
   * swatch clicks) for the rest of the page's life, and disconnect once the bundle resolves or the
   * wait window elapses so it can't outlive its purpose.
   */
  function observeCcBundle() {
    document.querySelectorAll('script[src*="' + CC_SRC + '"]').forEach(trackCcScript);
    if (bundleReady || bundleFailed) return;
    if (typeof MutationObserver === 'undefined' || !document.head) return;
    ccObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) trackCcScript(node);
        });
      });
    });
    ccObserver.observe(document.head, { childList: true, subtree: true });
    setTimeout(disconnectCcObserver, CC_WAIT_MS);
  }

  /** ConvertCart overlay / dialog is already open */
  function ccUiActive() {
    if (document.body.classList.contains('cc-search-results-shown')) return true;
    if (document.querySelector('.cc-search__dialog')) return true;
    var results = document.getElementById('cc-search-results');
    return !!(results && results.childElementCount > 0);
  }

  function searchQuery(input) {
    return (input && input.value ? input.value : '').trim();
  }

  function goNativeSearch(query) {
    if (!query) return;
    window.location.href =
      '/search?q=' + encodeURIComponent(query) + '&type=product';
  }

  function dispatchEnter(input) {
    var opts = {
      key: 'Enter',
      code: 'Enter',
      keyCode: 13,
      which: 13,
      bubbles: true,
      cancelable: true
    };
    // Guard against re-entering onKeydown for the synthetic Enter we dispatch to
    // ConvertCart. Without this, the capture-phase handler preventDefault()s its
    // own event and ConvertCart never sees a usable keypress (SKU/name search stalls).
    forwardingEnter = true;
    try {
      input.dispatchEvent(new KeyboardEvent('keydown', opts));
      input.dispatchEvent(new KeyboardEvent('keypress', opts));
    } finally {
      forwardingEnter = false;
    }
  }

  function waitForBundleThen(done) {
    var deadline = Date.now() + CC_WAIT_MS;
    (function poll() {
      if (bundleReady || bundleFailed || Date.now() >= deadline) {
        done();
        return;
      }
      setTimeout(poll, 100);
    })();
  }

  function commitToConvertCart(input, query) {
    dispatchEnter(input);
    // ConvertCart can report bundleReady while still failing to open UI (bot/privacy
    // contexts, init race). Fall back to native Shopify product search if the overlay
    // never appears so SKU/name queries still load results.
    setTimeout(function () {
      if (!ccUiActive()) goNativeSearch(query);
    }, CC_HANDOFF_FALLBACK_MS);
  }

  function commitSearch(input, query) {
    if (!query) query = searchQuery(input);
    if (bundleFailed) {
      goNativeSearch(query);
      return;
    }
    if (bundleReady) {
      commitToConvertCart(input, query);
      return;
    }
    waitForBundleThen(function () {
      if (bundleFailed) goNativeSearch(query);
      else if (bundleReady) commitToConvertCart(input, query);
      else goNativeSearch(query);
    });
  }

  function handleCommittedSearch(input, event) {
    var query = searchQuery(input);
    if (!query) {
      if (event) event.preventDefault();
      return;
    }
    if (event) event.preventDefault();
    commitSearch(input, query);
  }

  function onKeydown(event) {
    if (forwardingEnter) return;
    if (event.key !== 'Enter' || event.defaultPrevented) return;
    var input = event.target.closest(INPUT_SEL);
    if (!input) return;
    if (ccUiActive()) return;
    handleCommittedSearch(input, event);
  }

  function onClick(event) {
    var button = event.target.closest(SUBMIT_SEL);
    if (!button) return;
    var box = button.closest('.cch-main-search-box');
    var input = box && box.querySelector(INPUT_SEL);
    if (!input) return;
    handleCommittedSearch(input, event);
  }

  function init() {
    observeCcBundle();
    document.addEventListener('keydown', onKeydown, true);
    document.addEventListener('click', onClick, true);
  }

  if (document.documentElement) init();
  else document.addEventListener('DOMContentLoaded', init, { once: true });
})();
